import Blurb from "../pages/page-content/books/book-layout/Blurb.jsx";
import BookImage from "../pages/page-content/books/book-layout/BookImage.jsx";

export default function ActiveBook({book}) {
	
	return (
		<div id="active-book" className="active-book">
			
			
			<BookImage book={book} />
			
	
		{/* <h4 className="active-book-name">{book.bookName}</h4>*/}
			<div className="active-book-blurb">
				<Blurb blurb={book.blurb} />	
			</div>
			
		</div>
	)
}
